module.exports = __webpack_public_path__ + "img/maintop.e98e93d.png";